WiseMetering.Views.SpheraIntegrationDetails = Backbone.Marionette.ItemView.extend({
    className: 'dashboard full-height',
    template: 'templates/integrations/sphera/show/details',

    modelEvents: {
        'change': 'render'
    },

    serializeData: function() {
        return {
            ...this.model.toJSON(),
            site: this.model.site(),
            integrationIndicator: this.model.indicator()
        };
    }
});
